module.exports = __webpack_public_path__ + "static/img/case1Left2.a5a75c2f.png";